import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Rx";
import { Api } from "../api/api";

@Injectable()
export class ManagementService {
  private resourceUrl = Api.BACKEND_URL + "/management";

  constructor(private http: HttpClient) {}

  healthcheck(): Observable<Status> {
    return this.http.get(`${this.resourceUrl}/health`).catch(err => {
      throw new Error(err);
    });
  }

  info(): Observable<any> {
    return this.http.get(`${this.resourceUrl}/info`).catch(err => {
      throw new Error(err);
    });
  }
}

class Status {
  constructor(public status?: string) {
    this.status = status;
  }
}



// WEBPACK FOOTER //
// ./src/providers/management/management.provider.ts